import axios from 'axios';

const Instance = axios.create({
  
       baseURL: "https://api.skcements.com",
      // baseURL: "http://192.168.1.18:9092"

});

export default Instance;
